import { useEffect, useState } from 'react';
import { listenToAccountRequest, denyAccountRequest, approveAccountRequest, ACCOUNT_TYPES, ACCOUNT_AREAS, PERMISSIONS } from '../firebase/firebase'
import styles from './admin-page-style.module.css';
import ReservationList from './ReservationEditor';


function AdminPage({setShowNavBar}) {

    useEffect(() => setShowNavBar(true));

    return (
        <div id={styles.container}>
            <AccountRequest/>
            <ReservationList/>
        </div>
    )
}

export default AdminPage;


function AccountRequest() {

    const [accountRequests, setAccountRequests] = useState([]);
    const [activeRequest, setActiveRequest] = useState(null);
    useEffect(() => { listenToAccountRequest((requests) => setAccountRequests(requests));}, [setAccountRequests]);
    
    const approveRequest = (request) => {
        setActiveRequest(request);
    };

    const denyRequest = (request) => {
        if(window.confirm("Are you sure you want to deny this request?"))
            denyAccountRequest(request);
    }

    return (
        <div className={styles.panel_item} id={styles.account_request}>
            <h1>Account Requests</h1>
            <div className={styles.scroll}>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Account Type</th>
                            <th>Account Area</th>
                            <th>Requested On</th>
                            <th>Actions</th>
                        </tr>                        
                    </thead>
                    <tbody>
                        {
                            accountRequests.length > 0 ?
                            accountRequests.map((request) => 
                                <tr key={request.email}>
                                    <td key='name'>
                                        {`${request.first_name} ${request.last_name}`}
                                        <br/>
                                        {request.email}
                                        <br/>
                                        {request.phone_number}
                                    </td>
                                    <td key='type'>
                                        {request.account_type}
                                    </td>
                                    <td key='area'>
                                        {request.account_area}
                                    </td>
                                    <td key='timestamp'>{new Date(request.timestamp * 1000).toLocaleString({
                                            year: "2-digit", month: "numeric", day: "numeric", hour12: true, hour: 'numeric', minute: '2-digit'
                                        })}</td>
                                    {
                                        (request.pending != null) ? 
                                        <td key='status' style={{fontStyle: 'italic'}}>{request.pending}</td>
                                        :
                                        <td key='buttons'>
                                            <button onClick={() => approveRequest(request)}>Approve</button>
                                            <button onClick={() => denyRequest(request)}>Deny</button>
                                        </td>
                                    }
                                    
                                </tr>
                            ) : (
                                <tr key='no-accounts'>
                                    <td key='name'>No Account Requests</td>
                                    <td key='type'></td>
                                    <td key='area'></td>
                                    <td key='timestamp'></td>
                                    <td key='status'></td>                                        
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <RequestConfirmation request={activeRequest} setActiveRequest={setActiveRequest}/>
        </div>
    );
}

function RequestConfirmation({request, setActiveRequest}) {

    const [finalAccountType, setFinalAccountType] = useState('');
    const [finalAccountArea, setFinalAccountArea] = useState('');
    const [availableAreas, setAvailableAreas] = useState([]);
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        // const element = document.getElementById(styles.request_confirmation);
        setFinalAccountType(`Requested (${request?.account_type})`);
        setFinalAccountArea(`Requested (${request?.account_area})`);
        setPermissions(request?.permissions);


        for(const permission of PERMISSIONS) {
            document.getElementById(permission).checked = request?.permissions?.includes(permission);
        }

        document.getElementById('type').selectedIndex = 0;
        document.getElementById('area').selectedIndex = 0;
    }, [request])

    useEffect(() => {
        var typeCode = finalAccountType.toLocaleLowerCase();
        if(typeCode.startsWith('requested'))
            typeCode = typeCode.substring(11, typeCode.length-1);

        typeCode = typeCode.split(' ')[0];

        var availableAreas = ACCOUNT_AREAS[typeCode];

        if(availableAreas?.includes(request?.account_area))
            availableAreas = [`Requested (${request?.account_area})`, ...availableAreas]

        setAvailableAreas(availableAreas ?? []);

    }, [request, finalAccountType]);

    const approveRequest = () => {
        if(window.confirm("Are you sure you want to approve this request?")) {

            var accountType = finalAccountType;
            if(accountType.startsWith('Requested'))
                accountType = accountType.substring(11, accountType.length-1);

            var accountArea = finalAccountArea;
            if(accountArea.startsWith('Requested'))
                accountArea = accountArea.substring(11, accountArea.length-1);

            approveAccountRequest(request.id, accountType, accountArea, permissions);
            setActiveRequest();
        }
    }

    return (
        <div id={styles.request_confirmation} style={{display: request == null ? 'none': 'block'}}>
            <h1>Account Request Final Check</h1>
            <h2>{`${request?.first_name} ${request?.last_name}`}</h2>

            <div id={styles.account_details}>
                <div style={{marginRight: '16px'}}>
                    <h3>Account Type and Area:</h3>
                    <div className={styles.dropdown}>
                        <label htmlFor='type'>Account Type:</label>
                        <select id='type' onChange={(e) => setFinalAccountType(e.target.value)}>
                            <option>Requested ({request?.account_type})</option>
                            { ACCOUNT_TYPES.map((type) => <option key={type}>{type}</option>) }
                        </select>
                    </div>

                    <div className={styles.dropdown}>
                        <label htmlFor='area'>Account Area:</label>
                        <select id='area' onChange={(e) => setFinalAccountArea(e.target.value)}>
                            { availableAreas.map((type) => <option key={type}>{type}</option>) }
                        </select>
                    </div>
                </div>

                <div>
                    <h3>Account Permissions:</h3>
                    <div id={styles.permission_list}>
                        {
                            PERMISSIONS.map(permission => (
                                <div key={permission}>
                                    <input type='checkbox' id={permission} onChange={
                                        (e) => {
                                            if(e.target.checked) {
                                                if(!permissions.includes(permission))
                                                    permissions.push(permission);
                                                
                                                setPermissions(permissions);
                                            } else {
                                                const i = permissions.indexOf(permission);
                                                if (i > -1)
                                                    permissions.splice(i, 1);

                                                setPermissions(permissions);
                                            }
                                        }
                                    } />
                                    <label htmlFor={permission}>{permission}</label>
                                </div>
                            ))
                        }       
                    </div>                                     
                </div>
            </div> 
            <button onClick={() => approveRequest()}>Approve</button>
            <button onClick={() => setActiveRequest()}>Cancel</button>
        </div>
    )
}